"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = require("../../analytics");
class AnalyticsServiceMaacIE extends _analytics.AnalyticsService {
  constructor(config) {
    super(config);
  }
  composeTaggingEvents(_ref) {
    let {
      pageName,
      eventLabel,
      stepIndex,
      selectedOptionEvent
    } = _ref;
    const eventActionTag = super._composeTaggingActionEvent({
      pageName,
      eventLabel,
      stepIndex
    });
    const taggingEvents = super.composeTaggingEvents({
      pageName,
      eventLabel,
      stepIndex
    });
    taggingEvents.onToolAnswer = {
      ...eventActionTag,
      event_selected_options: selectedOptionEvent
    };
    return taggingEvents;
  }
}
var _default = AnalyticsServiceMaacIE;
exports.default = _default;